/* eslint-disable */
import React from 'react';
import Dayjs from 'dayjs';
import { Table } from 'semantic-ui-react';
import { isNumeric } from 'voca';

const ColoredHeader = props => (
    <Table.HeaderCell style={{ backgroundColor: '#bed6ec' }} {...props} />
);

const VacancyTable = ({ units, unitTypes }) => {
    // console.log(unitTypes)

    const bedrooms = unitTypes.map(({ bedroom }) => bedroom ? bedroom : 'Eff/Stu');
    const initialValues = bedrooms.reduce((acc, bedroom) => {
        // console.log(bedroom)
        return {
            ...acc,
            [bedroom]: {
                'Available': 0,
                '30': 0,
                '60': 0,
                '90': 0,
                '120': 0,
                '120+': 0
            }
        }
    }, {});
    const parsedUnits = parseUnits(units, initialValues);

    

    const sortedUnits = [].concat(
        Object.entries(parsedUnits).filter(([i]) => !isNumeric(i))
    ).concat(
        Object.entries(parsedUnits).filter(([i]) => isNumeric(i))
    );


    return (
        <Table celled collapsing singleLine textAlign='center' >
            <Table.Header>
                <Table.Row>
                    <ColoredHeader>Bedrooms</ColoredHeader>
                    <ColoredHeader>Vacant</ColoredHeader>
                    <ColoredHeader>0-30</ColoredHeader>
                    <ColoredHeader>30-60</ColoredHeader>
                    <ColoredHeader>60-90</ColoredHeader>
                    <ColoredHeader>90-120</ColoredHeader>
                    <ColoredHeader>120+</ColoredHeader>
                </Table.Row>
            </Table.Header>

            <Table.Body>

                {sortedUnits.map(([bedrooms, availability], i) => (
                    <Table.Row key={`avail-${i}`}>
                        <Table.Cell style={{ backgroundColor: '#bed6ec' }}>
                            {bedrooms}
                        </Table.Cell>
                        <Table.Cell>{availability['Available']}</Table.Cell>
                        <Table.Cell>{availability['30']}</Table.Cell>
                        <Table.Cell>{availability['60']}</Table.Cell>
                        <Table.Cell>{availability['90']}</Table.Cell>
                        <Table.Cell>{availability['120']}</Table.Cell>
                        <Table.Cell>{availability['120+']}</Table.Cell>
                    </Table.Row>
                ))}

            </Table.Body>

        </Table>
    );

};


const parseUnitType = type => ({
    // 'e': 'Eff/Stu',
    // 's': 'Eff/Stu',
    '0': '0',
    '1': '1',
    '2': '2',
    '3': '3'
})[type];

const parseAvailability = moveOut => {
    const currentDate = Dayjs();
    const moveOutDate = Dayjs(moveOut);
    const daysTillAvailable = moveOutDate.diff(currentDate, 'day');

    return daysTillAvailable;
};

const between = (num, min, max) => num >= min && num <= max;

const parseUnits = (units, initialValues) => units.reduce((acc, unit) => {

    // console.log(unit)

   let sea_view_mappings = { 
    'Model S 2':  0,
    'Model S 3':  0,
    'Model S 4':  0,
    'Model SL 1':  0,
    'Model SL 2':  0,
    'Model SL 3':  0,
    'Model SL1 1':  0,
    'Model SL1 2':  0,
    'Model SS':  0,
    'Model S 1':  0,
    'Model SB 1':  0,
    'Model SB 2':  0,
    'Model S2L':  0,
    'Model SWB':  0,
    'Model SSB':  0,
    'Model ALB':  1,
    'Model AT 1':  1,
    'Model AT 2':  1,
    'Model AKT 1':  1,
    'Model AKT 2':  1,
    'Model AKT 3':  1,
    'Model ABB':  1,
    'Model A 1':  1,
    'Model A 2':  1,
    'Model AGT':  1,
    'Model AC':  1,
    'Model BX':  2,
    'Model BRT 2':  2,
    'Model BRT 1':  2,
    'Model BS':  2,
    'Model BB3':  2,
    'Model B5':  2,
    'Model BRC':  2,
    'Model BBW':  2,
    'Model BL':  2,
    'Model BD':  2,
    'Model C2 1':  3,
    'Model C2 2':  3,
    'Model C3 1':  3,
    'Model C3 2':  3,
    'Model C4':  3,
    'Model C1':  3
    }

    
    const bedroom = parseUnitType(unit.unit_type[0].toLowerCase()) || sea_view_mappings[unit.unit_type]
    const daysTillAvailable = parseAvailability(unit.move_out);

    // console.log(unit.unit_type)
    // console.log(unit.unit_type[0])
    // console.log(unitType)
    // console.log('------------')

    if (!acc[bedroom]) {
        acc[bedroom] = {
            'Available': 0,
            '30': 0,
            '60': 0,
            '90': 0,
            '120': 0,
            '120+': 0
        };
    }

    if (between(daysTillAvailable, 121, 10000)) {
        acc[bedroom]['120+']++;
    }

    if (between(daysTillAvailable, 91, 120)) {
        acc[bedroom]['120']++;
    }

    if (between(daysTillAvailable, 61, 90)) {
        acc[bedroom]['90']++;
    }

    if (between(daysTillAvailable, 31, 60)){
        acc[bedroom]['60']++;
    }

    if (between(daysTillAvailable, 0, 30)) {
        acc[bedroom]['30']++;
    }

    if (unit.days_vacant) {
        acc[bedroom]['Available']++;
    }

    if (!unit.days_vacant && daysTillAvailable < 0) {
        acc[bedroom]['30']++;
    }

    return acc;
}, initialValues);


export default VacancyTable;
